<template>
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.93186 3.00943C5.93186 3.56172 6.37958 4.00943 6.93186 4.00943H9.17453C9.63042 4.00943 10 4.37901 10 4.83491C10 5.2908 9.63042 5.66038 9.17453 5.66038H6.93186C6.37958 5.66038 5.93186 6.10809 5.93186 6.66038V9.06814C5.93186 9.58279 5.51465 10 5 10C4.48535 10 4.06814 9.58279 4.06814 9.06814V6.66038C4.06814 6.10809 3.62042 5.66038 3.06814 5.66038H0.825472C0.369576 5.66038 0 5.2908 0 4.83491C0 4.37901 0.369576 4.00943 0.825472 4.00943H3.06814C3.62042 4.00943 4.06814 3.56172 4.06814 3.00943V0.931863C4.06814 0.417209 4.48535 0 5 0C5.51465 0 5.93186 0.41721 5.93186 0.931864V3.00943Z" class="icon-fill"/>
  </svg>

</template>

<script>
export default {
  name: 'plus'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>